import useTranslation from 'next-translate/useTranslation';

import { useMainModalSmallScreenLayout } from './useMainModalSmallScreenLayout';

/**
 * Returns the send-invites action label: short copy on narrow viewports, full copy otherwise.
 */
export function useSendInvitesButtonLabel(): string {
  const { t } = useTranslation('onboarding');
  const isSmallScreen = useMainModalSmallScreenLayout();

  return t(isSmallScreen
    ? 'invite_members_step.send_invites_cta_short'
    : 'invite_members_step.send_invites_cta');
}
